import styled from 'styled-components';
import { Text14Regular, Text24Bold } from '../../../components/utils/Text/Text.styles';

export const PageContainer = styled.div`
  max-height: 100dvh;
  height: 100%;
  display: flex;

  @media only screen and (max-width: 768px) {
    max-height: calc(100dvh - 5.6rem);
  }
`;

export const Title = styled(Text24Bold)`
  letter-spacing: -0.408px;
`;

export const Navigator = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2.4rem 0;
  min-width: 38rem;
  border-right: 1px solid #f3f4f6;
  background-color: #fff;

  @media screen and (max-width: 1100px) {
    max-width: 55rem;
  }

  @media screen and (max-width: 900px) {
    max-width: 25rem;
    min-width: 25rem;
  }

  @media screen and (max-width: 768px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
    border-right: none;
  }
`;

export const Content = styled.div`
  overflow: scroll;
  width: 100%;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 5.6rem);
`;

export const ListContainer = styled.div`
  overflow: auto;
  height: calc(100% - 5.6rem);
  display: flex;
  flex-direction: column;
`;

export const RowItem = styled.div`
  padding: 1.6rem 1.2rem;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #f3f4f6;
  gap: 0.4rem;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? '#EEF5FD' : 'transparent')};
`;

export const NumOfUsersText = styled(Text14Regular)`
  opacity: 0.68;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 1.6rem;
`;

export const AddCollectionButton = styled.button`
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%);
  height: 3.2rem;
  width: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      stroke: #fff;
    }
  }
`;
